import { Components, Theme } from "@mui/material";

export const muiTableContainerTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiTableContainer"> => ({});
